$(document).ready(function () {
	if(($('#slideshow').length > 0) && ($.fn.cycle)){
		var slideshow = $('#slideshow')
		
		if(slideshow.children().length <= 1){
			$('#slideshowControls, #slideshowNav').hide();
		}
		
		slideshow.cycle();
		
		/* Sequential image loading to reduce amount of data transfered on load */
		slideshow.on( 'cycle-before', function(e, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag ) {
			nextImg = $('#slideshow img').eq(optionHash.nextSlide + 1);
			if ( nextImg.attr("src") == "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="){
				nextImg.attr("src", nextImg.attr("data-img"));
			}	
		});
	}
		
	$(document).on('easytabs:ajax:complete', function(){
		if( $('.cycle-photo-slideshow').length > 0 ){
			initPhotoCycle();
			$(window).on('resize',function(){
				setGalControlHeight();
			});
		}
	});
	
	if($('#onboard-wrapper').length > 0){
		var t = $('#onboard-wrapper'),
			w = $(window);
		$('#onboard-wrapper img').load(function() {
			equalOnboardHeaders(t,w.width());
		});
		w.resize(function(){
            equalOnboardHeaders(t,w.width());
        });
	}
	
	initSelects();
});

function initPhotoCycle(){
	if(!$.fn.cycle){
		console.log('Cannot init Cycle');
		return;
	}else{
		$('.cycle-photo-slideshow').cycle();
	}
	$('.cycle-photo-slideshow').on( 'cycle-before', function(e, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag ) {
		nextImg = $('.cycle-photo-slideshow img').eq(optionHash.nextSlide + 1);
		if ( nextImg.attr("src") == "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="){
			nextImg.attr("src", nextImg.attr("data-img"));
		}
	});
	$('#gallery-main-img').load(function(){
		setGalControlHeight();
	});
}

function setGalControlHeight(){
	$('.gallery-controls').css('top',$('#gallery-main-img').outerHeight()/2);
}

function equalOnboardHolders(g){
	var h = 0;
	
	console.log(g);
	
	g.each(function(){
		if($(this).outerHeight() > h){
			h = $(this).outerHeight();
		}
	}).promise().done(function(){
		g.children('.onboard-item').css('height',h);
	});
}

function equalOnboardHeaders(t,w){
	var items = t.find('.onboard-item-holder'),
		headers = t.find('h3'),
		h = 0,
		g = null;
		
	items.children('.onboard-item').css('height','auto');
	headers.css('height','auto');
	
	if(w < 640){
		return;
	}else if(w >= 640 && w < 768){
		g = items.filter('.col-sm-6');
	}else{
		g = items;
	}
	
	gHeaders = g.find('h3');
	
	if(w >= 640){
		gHeaders.each(function(){
			if($(this).outerHeight() > h){
				h = $(this).outerHeight();
			}
		}).promise().done(function(){
			gHeaders.css('height',h);
			equalOnboardHolders(g);
		});
	}
}

function initSelects() {
	initSelect("Deck");
	initSelect("Deck-ap");
	initSelect("Deck-cb");
	initSelect("Deck-co");
	initSelect("Deck-cp");
	initSelect("Deck-di");
	initSelect("Deck-dp");
	initSelect("Deck-ep");
	initSelect("Deck-gp");
	initSelect("Deck-ip");
	initSelect("Deck-kp");
	initSelect("Deck-np");
	initSelect("Deck-pa");
	initSelect("Deck-rp");
	initSelect("Deck-ru");
	initSelect("Deck-sa");
	initSelect("Deck-sp");
	initSelect("Deck-ta");
	initSelect("Deck-tp");
	initSelect("Destinations");
	initSelect("BridgeCams");
	initSelect("AllCams");
	initSelect("Bridge Cams");
	initSelect("WeddingCams");
	initSelect("Ships");
	initSelect("PortsofCall");
	initSelect("Ita");
	initSelect("Shorex-Alaska");
	initSelect("Shorex-HawaiiTahiti");		
	initSelect("Shorex-AustraliaNZAsia");
	initSelect("Shorex-Caribbean");
	initSelect("Shorex-Canada");
	initSelect("Shorex-Coastal");
	initSelect("Shorex-Europe");
	initSelect("Shorex-SouthAmerica");
	initSelect("Shorex-Panama");
	initSelect("Shorex-World");
	initSelect("Shorex-AfricaIndia");
	initSelect("PortsofCall-Brochures");
	initSelect("select-ship");
	initSelect("activity");
	initSelect("Video-DVD");
	initSelect("Port-Directions");
}

function initSelect(id){ 
	$('#'+id).on('change', function(e) {
		/* Shouldnt need to open a _blank window
		if( this.id == "WeddingCams" || this.id =="BridgeCams" || this.id == "Port-Directions" || this.id.indexOf("Shorex") > -1 ){
			if (window.focus()) {
				self.focus();
			}
			if( this.id == "Port-Directions"){
				window.open($(this).val(),"_blank");
			} else if( this.id.indexOf("Shorex") > -1){
				window.open($(this).val(),"_blank");
			} else{
				window.open($(this).val(),"_blank", "resizable=yes,toolbar=no,location=no,width=650,height=460,directories=no,status=yes,scroll=no,scrollbars=no,menubar=no");
			}
			return;
		}
		*/  
    	window.location.href = DOMPurify.sanitize($(this).val());
  	});
}
